import { Dispatch } from "react";
import {
  CREATE_JOB_LIST_FAIL,
  CREATE_JOB_LIST_REQUEST,
  CREATE_JOB_LIST_SUCCESS,
  GET_APPLICANT_LIST_FAIL,
  GET_APPLICANT_LIST_REQUEST,
  GET_APPLICANT_LIST_SUCCESS,
  GET_JOB_DETAIL_FAIL,
  GET_JOB_DETAIL_REQUEST,
  GET_JOB_DETAIL_SUCCESS,
  GET_JOB_LIST_FAIL,
  GET_JOB_LIST_REQUEST,
  GET_JOB_LIST_SUCCESS,
  GET_SKILL_LIST_FAIL,
  GET_SKILL_LIST_REQUEST,
  GET_SKILL_LIST_SUCCESS,
} from "../../Constants/CareerConstants";

import { ApiConfig } from "../../Config/CommonConfig";
import { GETAPI, POSTAPI } from "../../API/Api";

export const JobListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_JOB_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.JobList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_JOB_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_JOB_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const JobCreateAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_JOB_LIST_REQUEST });
      let data = await POSTAPI(ApiConfig?.JobCreate, payload, true);
      if (data && data.status === true) {
        dispatch({
          type: CREATE_JOB_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: CREATE_JOB_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const SkillListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_SKILL_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.SkillsList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_SKILL_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_SKILL_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const JobDetailAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_JOB_DETAIL_REQUEST });

      let data = await GETAPI(ApiConfig?.JobDetail + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_JOB_DETAIL_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_JOB_DETAIL_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const JobApplicantsListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_APPLICANT_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.JobApplicantsList + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_APPLICANT_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_APPLICANT_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };
